const normalizePNumber = (value, previousValue) => {
    if (!value) {
        return value
    }

    let onlyNums = value.replace(/[^\d]/g, '');
    if(onlyNums.length > 10) {
        onlyNums =  onlyNums.slice(0, 10);
    }

    return onlyNums;
};

export default normalizePNumber;


// WEBPACK FOOTER //
// ./web/src/normalizers/normalizePNumber.js